import axios from "axios"
import { EntidadBancariaDtoProps } from "./DTOs/EntidadBancariaDto"
import { EntidadBancariaDtoIPagedEnumerableProps } from "./Schemas/EntidadBancariaDtoIPagedEnumerable"
import { SortingCriteria } from "./interfaces/SortingCriteria"

interface EntidadBancariaQueryParamsProps {
  Nombre?: string
  SortingCriteria?: SortingCriteria
  MaxResultCount?: number
  SkipCount?: number
}

export async function getEntidadesBancarias(
  queryParams: EntidadBancariaQueryParamsProps
): Promise<EntidadBancariaDtoIPagedEnumerableProps> {
  const { data } = await axios.get(`/EntidadBancaria/by-filters`, {
    params: queryParams,
  })
  return data
}

export async function getEntidadBancariaByIban(
  iban: string
): Promise<EntidadBancariaDtoProps> {
  const { data } = await axios.get(`/EntidadBancaria/by-iban/${iban}`)
  return data
}
